module.exports = __webpack_public_path__ + "img/1.42d00d35.png";